import Header from '../components/header';
import Footer from '../components/footer'
import React from 'react';
import '../index.css';
import { Container, Row, Col } from 'react-bootstrap';
import { getSkillsData } from '../data/skillData';
import { FaTools } from 'react-icons/fa';


function Skills() {
    const skills = getSkillsData();

    return (
        <>
            <Header />

            <Container className="skills-container fade-in-up gap-3 p-3">
                <Row className="justify-content-center p-3 mb-3">
                    <Col className="text-start d-flex align-items-center justify-content-start">
                        <FaTools className='page-img'></FaTools>
                        <h2 className="heading m-0">TOOLKIT</h2>
                    </Col>
                </Row>{skills.map((skillCategory, index) => (
                    <Row key={index} className="mb-4">
                        <Col>
                            <h3 className="heading3 mb-3 text-center text-md-start">
                                {skillCategory.category}
                            </h3>
                            <div className="my-2 w-100 d-flex align-items-center justify-content-center justify-content-md-start flex-wrap gap-2">
                                {skillCategory.items.map((item, itemIndex) => (
                                    <span key={itemIndex} className="badge me-1 mb-1">
                                        {item}
                                    </span>
                                ))}
                            </div>
                        </Col>
                    </Row>
                ))}
            </Container>

            <Footer />
        </>
    );
}

export { Skills };
